import { last, tryCatch, always } from 'ramda';
import { getFirstStep } from './getFirstStep';
import { getNextStep } from './getNextStep';
import { StepWizardSchemeError } from '../models';
import { EStepUnreachableErrorPolicy } from '../constants';
export function createStepHistory(params) {
  var _last;
  var scheme = params.scheme,
    firstStepCode = params.firstStepCode,
    _params$skipSteps = params.skipSteps,
    skipSteps = _params$skipSteps === void 0 ? [] : _params$skipSteps,
    answers = params.answers,
    stepCode = params.stepCode,
    unreachablePolicy = params.unreachablePolicy;
  var firstStep = getFirstStep({
    firstStepCode: firstStepCode,
    skipSteps: skipSteps,
    scheme: scheme,
    answers: answers
  });
  if (!firstStep) {
    throw new StepWizardSchemeError('Не удалось определить начальный шаг. Схема некорректна.');
  }

  /** Если искомый шаг - не указан, или равен первому, то возвращаем историю с этим шагом **/
  if (!stepCode || firstStepCode === stepCode) {
    return [firstStep];
  }

  /** Если искомый шаг в списке пропускаемых - кидаем ошибку или просто остаемся на первом шаге **/
  if (skipSteps.includes(stepCode)) {
    if (unreachablePolicy === EStepUnreachableErrorPolicy.MoveFirst) {
      return [firstStep];
    }
    throw new StepWizardSchemeError("\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0448\u0430\u0433 ".concat(stepCode, " \u043D\u0435\u0434\u043E\u0441\u0442\u0438\u0436\u0438\u043C, \u0442\u0430\u043A \u043A\u0430\u043A \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 skipSteps. \u0421\u0445\u0435\u043C\u0430 \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430."));
  }

  /**
   * Расчитываем историю прохождения до целевого шага включительно или пока не дойдем до конца формы либо
   * не упрмеся в "непроходимый" шаг
   * В случае невозможности достичь указанный шаг - кидаем ошибку или остаемся на первом шаге
   */
  var stepHistory = [firstStep];
  var currentStep = last(stepHistory);
  while (currentStep.code !== stepCode) {
    var nextStep = tryCatch(function () {
      return getNextStep({
        answers: answers,
        currentStep: currentStep,
        scheme: scheme,
        skipSteps: skipSteps
      });
    }, always(undefined))();
    if (!nextStep) {
      break;
    }
    stepHistory.push(nextStep);
    currentStep = nextStep;
  }
  if (((_last = last(stepHistory)) === null || _last === void 0 ? void 0 : _last.code) !== stepCode) {
    if (unreachablePolicy === EStepUnreachableErrorPolicy.MoveFirst) {
      return [firstStep];
    }
    throw new StepWizardSchemeError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0448\u0430\u0433\u043E\u0432 \u0434\u043B\u044F \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u0448\u0430\u0433\u0430 ".concat(stepCode, ". \u0421\u0445\u0435\u043C\u0430 \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430."));
  }
  return stepHistory;
}